import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class VTSTroubleshootService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetVTSStatus(): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_VTS_TROUBLESHOOT_GETVTSSTATUS_URL;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleObuStatus(input?: DataListModel, vehicleHashId?: string): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_VTS_TROUBLESHOOT_GETOBUSTATUS_URL;
    let queryString = this.authService.HandleAPIListInput(input);
    getVehicleUrl = getVehicleUrl + "?" + queryString;
    if (vehicleHashId) {
      getVehicleUrl = getVehicleUrl + "&vehicleHashId=" + vehicleHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVehicleObuStatus(input?: DataListModel, vehicleHashId?: string): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getVehicleExportUrl = WeGoConfig.API_VTS_TROUBLESHOOT_EXPORTOBUSTATUS_URL;
    getVehicleExportUrl = getVehicleExportUrl + "?" + queryString;
    if (vehicleHashId) {
      getVehicleExportUrl = getVehicleExportUrl + "&vehicleHashId=" + vehicleHashId;
    }
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVehicleExportUrl, options);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vts-troubleshoot/models/vehicletroubleshoot.service.ts